import { Controller } from "@hotwired/stimulus"

export default class PromotionLink extends Controller {  
  linkToPromo(event: MouseEvent): void {
    event.stopPropagation();
    const clickedElement = event.currentTarget as HTMLElement
    const href = clickedElement?.dataset.promotionLinkHrefValue
    if (href) window.location.href = href
  }

  noLinkToPromo(event: MouseEvent): void {
    event.stopPropagation();
  }
}
